/**
 * 주문 관련 공용 뮤테이션.
 * 소비자 order 상세·보스 예약판매 등에서 재사용하므로 src/api에 둠.
 */
import { gql } from "@apollo/client";

export const TOGGLE_PICKUP_COMPLETED = gql`
  mutation TogglePickupCompleted($id: Int!, $triggeredBy: UserType!) {
    togglePickupCompleted(id: $id, triggeredBy: $triggeredBy) {
      ok
      error
    }
  }
`;
